// extracted by mini-css-extract-plugin
module.exports = {"title":"CardAppIcon_title__6q2qG","titleContainer":"CardAppIcon_titleContainer__bKHw9","image":"CardAppIcon_image__IcgaE","headingContainer":"CardAppIcon_headingContainer__JgBi9"};